export default "__VITE_ASSET__C$Nq13rc__"